import React from 'react'

const Batch = ({variant = 'gold', children}) => {
  const variants = {
    gold: "border-gold border-[1px] bg-gold-gradient",
    silver: "border-silver border-[1px] bg-silver-gradient",
    bronze: "border-bronze border-[1px] bg-bronze-gradient",
  }
  return (
    <div className={`px-3 rounded-md font-normal py-[1px] text-white text-xs ${variants[variant]}`}>
      {children}
    </div>
  )
}

export default Batch;